(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gnav"]) return;
  try {
    

// Gナビ
$(function(){

  var $gNavElem = $('.js-gnav-list');

  $gNavElem.on('mouseenter', function () {
    $(this).addClass('is-opened');
  });

  $gNavElem.on('mouseleave', function () {
    $(this).removeClass('is-opened');
  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-works-template"] && !window.DesignMode) return;
  try {
    

	if (typeof jQuery !== "function") {
		let script = document.createElement('script');
		script.src = "//ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js";
		script.setAttribute('defer', true);
		document.head.append(script);
	}

	window.addEventListener('load', function(){
		var tageSelector = '.js-works-anchor';
		$(tageSelector).on('click', function(){
			let speed = 500;
			let href  = $(this).attr("href");
			let tage  = $(href == "#" || href == "" ? 'html' : href);
			let pos   = tage.offset().top;
			$("html, body").animate({scrollTop:pos}, speed, "swing");
			return false;
		});
	});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url + "?section_id=product-recommendations&limit=" + limit + "&product_id=" + productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      var productRecommendationsParent = productRecommendationsSection.parentElement;
      productRecommendationsParent.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      $(window).off('.productRecommendations');
      theme.initProductTitleAlignmentWatcher(productRecommendationsParent, '.productRecommendations');
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    $(window).off('.productRecommendations');
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
